import * as angular from "angular";

export class PreferencesService {
    private $cookies: any;

    constructor($cookies: any) {
        this.$cookies = $cookies;
    }

    use24Hour(): boolean {
        return this.$cookies.get("24hrTime") === "1";
    }
}

angular.module("vcServices").service("PreferencesService", PreferencesService);
